"use client";

import { useSyncExternalStore } from "react";
import Link from "next/link";
import { X, Cookie } from "lucide-react";
import {
  CookieConsentValue,
  persistCookieConsent,
  readCookieConsent,
  subscribeCookieConsent,
} from "@/lib/consent";

export function CookieConsent() {
  const consent = useSyncExternalStore(subscribeCookieConsent, readCookieConsent, () => null);
  const visible = consent === null;

  const handleDecision = (value: CookieConsentValue) => {
    persistCookieConsent(value);
    window.location.reload();
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Çerez ve KVKK bildirimi"
      className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6"
    >
      <div className="max-w-4xl mx-auto bg-gray-950 text-white rounded-2xl shadow-2xl px-6 py-5 flex flex-col md:flex-row items-start md:items-center gap-4">
        {/* İkon + metin */}
        <div className="flex items-start gap-3 flex-1">
          <Cookie className="h-5 w-5 shrink-0 mt-0.5 text-[var(--sf-accent)]" />
          <p className="text-sm leading-relaxed text-gray-300">
            Sitemizde deneyiminizi iyileştirmek amacıyla çerezler kullanıyoruz.
            Kişisel verileriniz 6698 sayılı KVKK kapsamında işlenmektedir.
            Detaylı bilgi için{" "}
            <Link href="/gizlilik" className="text-[var(--sf-accent)] hover:underline font-medium">
              Gizlilik Politikası
            </Link>
            &apos;nı inceleyebilirsiniz.
          </p>
        </div>

        {/* Butonlar */}
        <div className="flex items-center gap-3 shrink-0 w-full md:w-auto">
          <button
            onClick={() => handleDecision("accepted")}
            className="flex-1 md:flex-none px-5 py-2 rounded-[var(--sf-radius)] text-sm font-semibold bg-[var(--sf-accent)] text-white hover:opacity-90 transition-opacity cursor-pointer"
          >
            Kabul Et
          </button>
          <button
            onClick={() => handleDecision("declined")}
            className="flex-1 md:flex-none px-5 py-2 rounded-[var(--sf-radius)] text-sm font-semibold bg-gray-800 text-gray-300 hover:bg-gray-700 transition-colors cursor-pointer"
          >
            Reddet
          </button>
          <button
            onClick={() => handleDecision("declined")}
            aria-label="Kapat"
            className="p-1.5 text-gray-500 hover:text-white transition-colors cursor-pointer"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
